//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const mainbookPopup = {
   open:false,
   pages:[]
};

const sentencePopup = {
    open:false,
    pages:[]
}

const aiAnswerPopup = {
    open: false,
    questions: []
}

const matchMakingPopup = {
    open: false
}

export const mainbookPageView = (state = mainbookPopup, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokeMainBook:
            return ({ ...state, ...action.payload });
        case ActionTypes.alert.removeMainBook:
            return ({ ...state, ...action.payload });
        default:
            return state;
    }
};

export const sentenceView = (state = sentencePopup, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokeSentence:
            return ({ ...state, ...action.payload });
        case ActionTypes.alert.removeSentence:
            return ({ ...state, ...action.payload });
        default:
            return state;
    }
};

export const aiAnswerView = (state = aiAnswerPopup, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokeAiAnswer:
            return ({ ...state, ...action.payload });
        case ActionTypes.alert.removeAiAnswer:
            return ({ ...state, ...action.payload });
        default:
            return state;
    }
};

export const matchMakingView = (state = matchMakingPopup, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokeMatchMaking:
            return ({ ...state, ...action.payload });
        case ActionTypes.alert.revokeMatchMaking:
            return ({ ...state, ...action.payload });
        default:
            return state;
    }
};

const ebookGalleryViewInit = {
   open:false,
   pages:[]
};

const answerViewInit = {
    open:false,
   pages:[]
}

export const ebookGalleryView = (state = ebookGalleryViewInit, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokeEbookGalleryViewer:
            return ({ ...state, ...action.payload });
        case ActionTypes.alert.removeEbookGalleryView:
            return ({ ...state, ...action.payload });
        default:
            return state;
    }
};

const storyViewInit = {
    open:false,
    pages:[]
}

export const storyView = (state = storyViewInit, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokeStory:
            return ({ ...state, ...action.payload });
        case ActionTypes.alert.removeStory:
            return ({ ...state, ...action.payload , type:'' });
        default:
            return state;
    }
};

export const answerView = (state = answerViewInit, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokeAnswer:
            return ({ ...state, ...action.payload });
        case ActionTypes.alert.removeAnswer:
            return ({ ...state, ...action.payload , type:'' });
        default:
            return state;
    }
};

const pdfViewInit = {
    open: false,
    pdf: null
}

export const pdfView = (state = pdfViewInit, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokePDF:
            return ({ ...state, ...action.payload });
        case ActionTypes.alert.removePDF:
            return ({ ...state, ...action.payload });
        default:
            return state;
    }
};

const activityStandardsViewInit = {
    open: false,
    activities: [],
    standards: [],
    enabledStateCodes: [],
    bookData: null,
    units: [],
    pages: [],
    currentPage: null
}

export const activityStandardsView = (state = activityStandardsViewInit, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokeActivityStandards:
            return ({ ...state, ...action.payload });
        case ActionTypes.alert.removeActivityStandards:
            return ({ ...state, ...action.payload });
        default:
            return state;
    }
};